import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import './StatusPage.css';

export function NotFoundPage() {
  const { t } = useTranslation();

  return (
    <div className="fa-status-page">
      <p className="fa-status-page__code">404</p>
      <h1 className="fa-status-page__title">{t('errors.notFoundTitle')}</h1>
      <p className="fa-status-page__body">{t('errors.notFoundBody')}</p>
      <Link className="fa-status-page__link" to="/dashboard">
        {t('common.backToDashboard')}
      </Link>
    </div>
  );
}
